import type { paths } from "@/api-schema";
import { alphartisApiAxios } from "@/config/axios";
import { useQuery } from "@tanstack/react-query";
import { optionsWithDefaults } from "../_helpers/options-with-defaults";
import { Options } from "../_types";

export const BRANCH_BY_UUID_RESOURCE = "branch" as const;
export const BRANCH_BY_UUID_API_PATH = `/v1/${BRANCH_BY_UUID_RESOURCE}/{uuid}` as const;

export type BranchByUuidParameters = paths[typeof BRANCH_BY_UUID_API_PATH]["get"]["parameters"]["query"];
export type BranchByUuidResponse =
  paths[typeof BRANCH_BY_UUID_API_PATH]["get"]["responses"][200]["content"]["application/json"];

export function useBranchByUuidQuery(uuid: string, options?: Options<BranchByUuidParameters, never>) {
  const optionsWithDefaultsResolved = optionsWithDefaults<Options<BranchByUuidParameters, never>>(options);

  const requestParameters = {
    ...(optionsWithDefaultsResolved.parameters || {}),
    extend: optionsWithDefaultsResolved.parameters?.extend || [],
  };

  return useQuery({
    enabled: !!uuid,
    queryKey: [BRANCH_BY_UUID_RESOURCE, uuid, { parameters: requestParameters }],
    queryFn: async () => {
      const response = await alphartisApiAxios.get<BranchByUuidResponse>(`/v1/${BRANCH_BY_UUID_RESOURCE}/${uuid}`, {
        params: requestParameters,
      });

      return response.data;
    },
  });
}
